<template>
    <div class="home-page">
		<Header></Header>
		<div class="content">
			<div class="nav flex">
				<div class="back" @click="back">
					<img src="static/images/return.png" />
				</div>
				<span class="">{{$t('myAccount')}}</span>
			</div>
			<div class="mt30" v-if="info!=''">
				<div class="por flex-center disflex">
					<div class="ac">
						<div class="accout-img">
              <img class="" src="static/images/accout-img.png" />
            </div>
					</div>
				</div>
				<div class="price fs33 w556 mt100">
          <div class="name ac mt10 ">
          	<span class="fs40 name-span" v-if="!isEdit">{{info.name}}</span>
          	<input class="fs40 name-input" v-if="isEdit" v-model="name" />
          	<span class="crff1d4f fs33" @click="editName"><img width="40" src="../../static/images/edit.png" /></span>
          </div>
          <div class="phone ac ovhidden fs40">{{info.mobile}}</div>
					<div class="ac mt50">
						<span>{{$t('Member_since')}}</span>
						<span>:</span>
						<div class="account-input">{{info.created_at.trim().split(" ")[0].replace(/-/g,'/')}}</div>
					</div>
					<div class="ac">
						<span>{{$t('Last_login')}}</span>
						<span>:</span>
						<div class="account-input">{{$utils.getDate()}}</div>
					</div>
					<div class="ac">
						<span>{{$t('My_score')}}</span>
						<span>:</span>
						<div class="account-input">{{info.score}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Header from '../components/header'
export default {
    components:{
		Header
    },
    data() {
        return {
			disAbled:'',
			edit:'Edit',
			isEdit:false,
			info:'',
			name:'',

		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.edit = this.$t('Edit')
		this.getHome();

	},
    methods: {
		back(){
			this.$router.go(-1);
		},
		editName(){
			let that = this;
			if(that.name==''){
				that.name = that.info.name
			}
			if(this.edit==this.$t('Save')){
				this.edit=this.$t('Edit')
				this.isEdit = false;
				let data = {'token':localStorage.getItem('token'),uuid:localStorage.getItem('uuid'),'name':that.name}
				that.$api.post('/user/updata',data,r =>{
					that.$parent.returnCode(r,function(){
						that.info = r.data
						that.$parent.loadModal(false);
					});

				})
			}else{
				this.edit=this.$t('Save')
				this.isEdit = true;
			}
		},
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			let data = {'token':localStorage.getItem('token'),uuid:localStorage.getItem('uuid')}
			that.$api.post('/user/info',data,r =>{
				that.$parent.returnCode(r,function(){
					that.info = r.data
					that.$parent.loadModal(false);
                });

			})
		}
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/myAccount.vue